import React, { useState } from 'react';
import { FiX, FiZap, FiStar, FiTrendingUp } from 'react-icons/fi';
import api from '../../utils/api';
import toast from 'react-hot-toast';

const PLANS = [
  { id: 'starter', name: 'Starter', credits: '50,000', price: '$5', icon: <FiZap size={24} />, color: '#3b82f6', popular: false },
  { id: 'pro', name: 'Pro', credits: '150,000', price: '$10', icon: <FiStar size={24} />, color: '#8b5cf6', popular: true },
  { id: 'power', name: 'Power', credits: '500,000', price: '$25', icon: <FiTrendingUp size={24} />, color: '#f59e0b', popular: false }
];

export default function CreditPlans({ isOpen, onClose, currentCredits = 0 }) {
  const [loading, setLoading] = useState(null);

  if (!isOpen) return null;

  const handlePurchase = async (planId) => {
    setLoading(planId);
    try {
      const visitorSessionId = sessionStorage.getItem('rc_visitor_session') || '';
      const { data } = await api.post('/credits/purchase', { planId, visitorSessionId });
      window.location.href = data.url;
    } catch (err) {
      toast.error('Failed to start checkout. Please try again.');
    } finally {
      setLoading(null);
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} style={styles.closeBtn}><FiX size={20} /></button>

        <div style={styles.header}>
          <h2 style={styles.title}>Get More Credits</h2>
          <p style={styles.subtitle}>
            You have <strong style={{ color: 'var(--accent)' }}>{currentCredits.toLocaleString()}</strong> credits remaining
          </p>
        </div>

        <div style={styles.plans}>
          {PLANS.map(plan => (
            <div key={plan.id} style={{ ...styles.planCard, ...(plan.popular ? styles.popularCard : {}) }}>
              {plan.popular && <div style={styles.popularBadge}>Best Value</div>}
              <div style={{ ...styles.planIcon, background: plan.color + '22', color: plan.color }}>
                {plan.icon}
              </div>
              <h3 style={styles.planName}>{plan.name}</h3>
              <div style={styles.planCredits}>{plan.credits}</div>
              <div style={styles.planCreditsLabel}>credits</div>
              <div style={styles.planPrice}>{plan.price}</div>
              <button
                onClick={() => handlePurchase(plan.id)}
                disabled={loading === plan.id}
                style={{ ...styles.buyBtn, ...(plan.popular ? styles.buyBtnPopular : {}) }}
              >
                {loading === plan.id ? 'Processing...' : `Buy ${plan.name}`}
              </button>
            </div>
          ))}
        </div>

        <p style={styles.note}>1 credit = 1 word generated. Secure payment via Stripe.</p>
      </div>
    </div>
  );
}

const styles = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: 20 },
  modal: { background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 20, padding: '24px', width: '100%', maxWidth: 680, position: 'relative', maxHeight: '90vh', overflowY: 'auto' },
  closeBtn: { position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', padding: 4 },
  header: { textAlign: 'center', marginBottom: 28 },
  title: { fontSize: 24, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 8 },
  subtitle: { fontSize: 15, color: 'var(--text-secondary)' },
  plans: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12 },
  planCard: { background: 'var(--bg-primary)', border: '1px solid var(--border)', borderRadius: 14, padding: '24px 16px', textAlign: 'center', position: 'relative', transition: 'border-color 0.2s' },
  popularCard: { border: '2px solid var(--accent)', transform: 'scale(1.04)' },
  popularBadge: { position: 'absolute', top: -11, left: '50%', transform: 'translateX(-50%)', background: 'var(--accent)', color: 'white', padding: '3px 14px', borderRadius: 20, fontSize: 11, fontWeight: 700, whiteSpace: 'nowrap' },
  planIcon: { width: 48, height: 48, borderRadius: 12, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' },
  planName: { fontSize: 16, fontWeight: 700, color: 'var(--text-primary)', marginBottom: 4 },
  planCredits: { fontSize: 28, fontWeight: 800, color: 'var(--text-primary)' },
  planCreditsLabel: { fontSize: 12, color: 'var(--text-muted)', marginBottom: 8 },
  planPrice: { fontSize: 20, fontWeight: 700, color: 'var(--accent)', marginBottom: 14 },
  buyBtn: { width: '100%', padding: '10px', background: 'var(--bg-secondary)', border: '1px solid var(--border)', borderRadius: 8, color: 'var(--text-primary)', fontSize: 14, fontWeight: 600, cursor: 'pointer', transition: 'background 0.2s' },
  buyBtnPopular: { background: 'var(--accent)', border: 'none', color: 'white' },
  note: { textAlign: 'center', fontSize: 12, color: 'var(--text-muted)', marginTop: 20 }
};
